import { render, staticRenderFns } from "./TheBoat.vue?vue&type=template&id=147385ca&scoped=true&"
import script from "./TheBoat.vue?vue&type=script&lang=js&"
export * from "./TheBoat.vue?vue&type=script&lang=js&"
import style0 from "./TheBoat.vue?vue&type=style&index=0&id=147385ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147385ca",
  null
  
)

export default component.exports